import { SdkMethodPayloadInterface } from "@modules/sdk/methods/SdkMethodPayloadInterface";

import { WISHLISTS_SDK_METHODS } from "../constants";
import { WishlistsSharedStateKit } from "../state_kit/WishlistsSharedStateKit";

class GetWishlistsSharedStateKitSdkMethodPayload
    implements SdkMethodPayloadInterface<WishlistsSharedStateKit>
{
    public readonly methodName: WISHLISTS_SDK_METHODS.GET_WISHLISTS_SHARED_STATE_KIT;

    constructor(
        public readonly onSuccess: (result: WishlistsSharedStateKit) => void,
        public readonly onError: (error: Error) => void
    ) {
        this.methodName = WISHLISTS_SDK_METHODS.GET_WISHLISTS_SHARED_STATE_KIT;
        this.onSuccess = onSuccess;
        this.onError = onError;
    }
}

export default GetWishlistsSharedStateKitSdkMethodPayload;
